import React from "react";
import * as ReactDOMClient from "react-dom/client";
import { Controller } from "@hotwired/stimulus";
import { ChatPanel } from "../components/ChatPanel/ChatPanel";

// Not extending ReactController on purpose: the chat panel lives inside a
// data-turbo-permanent element, so we want the React root to survive Turbo
// navigations instead of being unmounted on Stimulus disconnect.
export class ChatPanelController extends Controller {
  static values = { props: Object };

  connect() {
    if (document.documentElement.hasAttribute("data-turbo-preview")) return;
    if (this.element.__reactRoot) return;
    const root = ReactDOMClient.createRoot(this.element);
    this.element.__reactRoot = root;
    root.render(<ChatPanel {...this.propsValue} />);
  }
}
